import { render, staticRenderFns } from "./ContractServiceDetails.vue?vue&type=template&id=3a964bec&scoped=true&"
import script from "./ContractServiceDetails.vue?vue&type=script&lang=js&"
export * from "./ContractServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractServiceDetails.vue?vue&type=style&index=0&id=3a964bec&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a964bec",
  null
  
)

export default component.exports